import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { receiptControllerContext } from './ReceiptController'

function ReceiptHeader() {
  const receiptController = useContext(receiptControllerContext)
  const receipt = receiptController.receipt[0]
  const receipt_for = receipt.receipt_for
  const receipt_title =
    (receipt._id)
    ? `Editing Receipt ${receipt._id.toUpperCase()}`
    : (receipt_for.item_name === 'Invoice')
      ? `Creating Official Receipt for ${receipt_for.item_name} ${receipt_for.item._id.toString().toUpperCase()}`
      : `Creating Official Receipt for ${receipt_for.item.customer_details.account_name}'s Credit Account ${receipt_for.item.credit_accounts[receipt_for.item.credit_accounts.length - 1].credit_account_number}`

  return ( <ContentHeader title={receipt_title}/> )
}

export default React.memo(ReceiptHeader)
